import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GlobalContext } from '../../lib/GlobalVar';
import {
    Contexto, definirSenhaExterna,
    PublicoProduto, PublicoHistoria, PublicoGuiaUrl,
} from '../../personalizados/PerguntarDados/api';
import Login from '../Login';
import { BabitaLogo } from '../BabitaLogo';
import './PerguntarPublico.css';

// Landing PUBLICA unificada mostrada em /perguntar quando NAO ha sessao. Um so lugar, tres
// caminhos: (a) Explorar — publico, sem login (guias, consulta de produto, historia da marca);
// (b) Sou revendedora — CPF/CNPJ + senha (mesma logica de Revendedora.jsx); (c) Sou da equipe —
// o <Login/> de funcionario existente. Assim que qualquer login valida, o GlobalContext ganha
// `user` e o ChatDireto (que renderiza esta landing enquanto !user) troca para o chat
// (PerguntarDados) — o MESMO motor dos tres perfis, escopado no backend pelo `solicitante`.

function soDigitos(v) { return String(v || '').replace(/\D/g, ''); }

const GUIAS = [
    {
        nome: 'revendedora',
        etiqueta: 'Guia',
        titulo: 'Bem-vinda ao Time Babita',
        desc: 'O guia da revendedora: como comprar, girar o estoque e crescer com a Babita.',
        peso: '19 páginas A4 · 2,0 MB',
        capa: '/guias/capa-revendedora.jpg',
    },
    {
        nome: 'liga',
        etiqueta: 'Programa',
        titulo: 'Liga Fashion Stars',
        desc: 'Tudo sobre a Liga: níveis, benefícios e como subir de estrela.',
        peso: '9 páginas A4 · 1,2 MB',
        capa: '/guias/capa-liga.jpg',
    },
];

export default function PerguntarPublico() {
    const { login } = useContext(GlobalContext);
    const location = useLocation();
    const inicial = new URLSearchParams(location.search).get('modo');
    const [modo, setModo] = useState(
        inicial === 'revendedora' || inicial === 'equipe' ? inicial : 'explorar'
    );

    if (modo === 'equipe') {
        return (
            <div className="pp-auth">
                <button className="pp-back" onClick={() => setModo('explorar')} aria-label="Voltar">
                    &larr; Explorar
                </button>
                <Login redirectTo="/perguntar" />
            </div>
        );
    }

    if (modo === 'revendedora') {
        return <ModoRevendedora login={login} onVoltar={() => setModo('explorar')} />;
    }

    return <ModoExplorar modo={modo} setModo={setModo} />;
}

/* ============================ MODO EXPLORAR (publico) ============================ */
// Direcao visual de 04/09/2026 (mockup do Rafael + capa dos guias): creme e preto da casa com os
// dois acentos da CAPA DOS PDFs — azul-noite #1F1F45 e dourado #E8B10A. O dourado NUNCA e texto
// (1,9:1 sobre creme): so filete, barra e fundo de selo. Para texto dourado existe o #8A6B00.

function ModoExplorar({ modo, setModo }) {
    return (
        <div className="pp">
            <header className="pp-topbar">
                <div className="pp-brand">
                    <span className="pp-logo"><BabitaLogo color="var(--ink)" /></span>
                    <span className="pp-brand-name">Babita</span>
                </div>
                <div className="pp-topbar-actions">
                    <button className="btn ghost sm" onClick={() => setModo('revendedora')}>Sou revendedora</button>
                    <button className="btn sm" onClick={() => setModo('equipe')}>Sou da equipe</button>
                </div>
            </header>

            <main className="pp-main">
                <section className="pp-hero pp-reveal">
                    <div className="pp-hero-eyebrow">Belo Horizonte · desde 1982</div>
                    <h1 className="pp-hero-title">O que você quer saber<br /><em>sobre a Babita</em> hoje?</h1>
                    <p className="pp-hero-sub">
                        Consulte uma peça pelo nome, pela página da revista ou pelo código, leia os guias
                        e conheça a marca — sem precisar entrar. Se você é revendedora ou da equipe,
                        entre para ver preço, disponibilidade e os seus dados.
                    </p>

                    <div className="pp-modes" role="tablist" aria-label="Modo de acesso">
                        <button className="pp-mode is-active" aria-selected="true" role="tab">
                            <span className="pp-mode-k">Explorar</span>
                            <span className="pp-mode-d">Público · sem login</span>
                        </button>
                        <button className="pp-mode" role="tab" onClick={() => setModo('revendedora')}>
                            <span className="pp-mode-k">Sou revendedora</span>
                            <span className="pp-mode-d">CPF/CNPJ + senha</span>
                        </button>
                        <button className="pp-mode" role="tab" onClick={() => setModo('equipe')}>
                            <span className="pp-mode-k">Sou da equipe</span>
                            <span className="pp-mode-d">Login Babita</span>
                        </button>
                    </div>
                </section>

                {/* Tutoriais em video + manual para as vendedoras: /tutoriais EXIGE login do Central (a pagina leva ao login e volta) */}
                <Link to="/tutoriais" className="pp-tut-card pp-reveal">
                    <span className="pp-tut-play" aria-hidden="true">
                        <svg viewBox="0 0 24 24" focusable="false"><path d="M8 5.5v13l11-6.5z" /></svg>
                    </span>
                    <span className="pp-tut-corpo">
                        <span className="pp-tut-t">Tutoriais em vídeo</span>
                        <span className="pp-tut-d">Passo a passo do app para vendedoras: assista ao vídeo ou leia o manual. Entre com o seu login Babita.</span>
                    </span>
                    <span className="pp-tut-seta" aria-hidden="true">&rarr;</span>
                </Link>

                <SecaoProduto />
                <SecaoGuias />
                <SecaoHistoria />
            </main>

            <footer className="pp-foot">
                <span>Babita · Belo Horizonte · desde 1982</span>
                <span className="pp-foot-legal">Preço e disponibilidade só depois de entrar</span>
            </footer>
        </div>
    );
}

/* ------------------------------- Guias (PDF) ------------------------------- */

function SecaoGuias() {
    const [preview, setPreview] = useState(null); // {nome, titulo} | null

    const abrirNovaAba = useCallback((nome) => {
        window.open(PublicoGuiaUrl(nome), '_blank', 'noopener');
    }, []);

    // iframe de PDF nao abre em iPhone: quem esta no celular precisa do arquivo na mao.
    const baixar = useCallback((nome) => {
        window.location.href = PublicoGuiaUrl(nome) + '&baixar=1';
    }, []);

    // Fecha a pre-visualizacao no Esc (a modal e a unica coisa da pagina que prende o foco).
    useEffect(() => {
        if (!preview) return;
        const onKey = (ev) => { if (ev.key === 'Escape') setPreview(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [preview]);

    return (
        <section className="pp-section">
            <div className="pp-section-head">
                <div className="pp-secao-rot">Guias em PDF</div>
                <h2 className="pp-section-title">Comece por aqui</h2>
            </div>

            <div className="pp-guias-grid">
                {GUIAS.map((g, i) => (
                    <article key={g.nome} className="pp-guia-card pp-reveal" style={{ animationDelay: `${i * 90}ms` }}>
                        <div className="pp-guia-capa">
                            <img src={g.capa} alt={'Capa do guia ' + g.titulo} width="520" height="735" loading="lazy" />
                            <span className="pp-guia-selo">{g.etiqueta}</span>
                        </div>
                        <div className="pp-guia-corpo">
                            <h3 className="pp-guia-title">{g.titulo}</h3>
                            <div className="pp-guia-peso">PDF · {g.peso}</div>
                            <p className="pp-guia-desc">{g.desc}</p>
                            <div className="pp-guia-actions">
                                <button className="btn sm" onClick={() => setPreview(g)}>Pré-visualizar</button>
                                <button className="btn ghost sm" onClick={() => abrirNovaAba(g.nome)}>Nova aba</button>
                                <button className="btn ghost sm" onClick={() => baixar(g.nome)}>Baixar</button>
                            </div>
                        </div>
                    </article>
                ))}
            </div>

            {preview && (
                <div className="pp-modal-mask" onClick={() => setPreview(null)}>
                    <div className="pp-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={preview.titulo}>
                        <div className="pp-modal-head">
                            <span className="pp-modal-title">{preview.titulo} <span className="pp-guia-peso">PDF · {preview.peso}</span></span>
                            <div className="pp-modal-head-actions">
                                <button className="btn ghost sm" onClick={() => abrirNovaAba(preview.nome)}>Nova aba</button>
                                <button className="btn ghost sm" onClick={() => baixar(preview.nome)}>Baixar</button>
                                <button className="btn sm" onClick={() => setPreview(null)}>Fechar</button>
                            </div>
                        </div>
                        <iframe
                            className="pp-modal-frame"
                            title={preview.titulo}
                            src={PublicoGuiaUrl(preview.nome)}
                        />
                    </div>
                </div>
            )}
        </section>
    );
}

/* ---------------------------- Consultar produto ---------------------------- */
// Um campo so, que entende pagina ("pag 11"), codigo/referencia ("1595812"), marca e palavras da
// descricao — e diz em palavras o que entendeu. So peca de revista lancada nos ultimos 365 dias.

const EXEMPLOS = ['vestido midi', 'pág. 11', 'Massacle', '1595812', 'blusa carisma'];

function SecaoProduto() {
    const [q, setQ] = useState('');
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');
    const [resp, setResp] = useState(null);
    const [zoom, setZoom] = useState(null);   // peca aberta na lupa
    // 8 pecas de saida: com 24 a pagina passava de 9.300 px de rolagem no celular
    const [todas, setTodas] = useState(false);

    const buscar = useCallback(async (termo) => {
        setLoading(true); setErro('');
        const r = await PublicoProduto({ q: termo });
        setLoading(false);
        if (r.Error) { setErro(r.Error); setResp(null); return; }
        setResp(r);
    }, []);

    // Vitrine: ao abrir a pagina ja mostra as pecas do lancamento mais recente.
    useEffect(() => { buscar(''); }, [buscar]);

    useEffect(() => {
        if (!zoom) return;
        const onKey = (ev) => { if (ev.key === 'Escape') setZoom(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [zoom]);

    function enviar(e) {
        e.preventDefault();
        buscar(q.trim());
    }

    const produtos = resp?.produtos || [];
    const inter = resp?.interpretacao || [];

    return (
        <section className="pp-section">
            <div className="pp-section-head">
                <div className="pp-secao-rot">Consultar produto</div>
                <h2 className="pp-section-title">Procure uma peça</h2>
            </div>

            <form className="pp-busca" onSubmit={enviar}>
                <label className="pp-busca-campo">
                    <span className="pp-busca-lbl">Nome, marca, página ou código da revista</span>
                    <span className="pp-busca-linha">
                        <input
                            className="input"
                            type="search"
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="vestido midi · pág. 11 · Massacle · 1595812"
                            aria-label="Buscar peça"
                        />
                        <button className="btn" type="submit" disabled={loading}>{loading ? 'Buscando…' : 'Buscar'}</button>
                    </span>
                </label>
                <div className="pp-busca-exemplos">
                    <span className="pp-busca-exemplos-lbl">Tente</span>
                    {EXEMPLOS.map((ex) => (
                        <button key={ex} type="button" className="pp-tag" onClick={() => { setQ(ex); buscar(ex); }}>{ex}</button>
                    ))}
                    {q && <button type="button" className="pp-tag pp-tag-x" onClick={() => { setQ(''); buscar(''); }}>limpar</button>}
                </div>
            </form>

            <div className="pp-busca-estado" aria-live="polite">
                {loading && <span className="pp-mini-spin" aria-hidden="true" />}
                {loading && 'lendo o catálogo…'}
                {!loading && resp && (
                    resp.vitrine
                        ? <>Peças do lançamento mais recente · <b>{resp.total}</b> de 24 · {resp.janela}</>
                        : <>
                            {inter.length > 0 && <>Entendi: <b>{inter.join(' + ')}</b> · </>}
                            <b>{resp.total}</b> {resp.total === 1 ? 'peça' : 'peças'} · {resp.janela}
                          </>
                )}
            </div>

            {erro && <div className="pp-note pp-note-err">{erro}</div>}

            {!loading && resp && produtos.length === 0 && !erro && (
                <div className="pp-vazio">
                    <div className="pp-vazio-t">Não achei essa peça</div>
                    <div className="pp-vazio-d">
                        A busca cobre as revistas lançadas nos últimos 365 dias. Tente o nome
                        (“vestido midi”), a marca, a página (“pág. 11”) ou o código da revista.
                    </div>
                </div>
            )}

            {produtos.length > 0 && (
                <>
                    <div className="pp-prod-grid">
                        {(todas ? produtos : produtos.slice(0, 8)).map((p, i) => <CardProduto key={p.ref || i} p={p} i={i} onZoom={setZoom} />)}
                    </div>
                    {produtos.length > 8 && (
                        <button type="button" className="btn ghost pp-ver-mais" onClick={() => setTodas((v) => !v)}>
                            {todas ? 'Mostrar só as 8 primeiras' : `Ver as ${produtos.length} peças`}
                        </button>
                    )}
                </>
            )}

            {zoom && (
                <div className="pp-modal-mask" onClick={() => setZoom(null)}>
                    <div className="pp-zoom" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={zoom.descricao || 'Peça'}>
                        <img src={zoom.foto} alt={zoom.descricao || 'Peça Babita'} />
                        <div className="pp-zoom-info">
                            <span className="pp-prod-marca">{zoom.marca}</span>
                            <h3 className="pp-prod-title">{zoom.descricao}</h3>
                            <div className="pp-prod-ref">
                                {zoom.ref && <span className="mono">Ref. {zoom.ref}</span>}
                                {zoom.pagina && <span>Pág. {zoom.pagina}</span>}
                                {zoom.revista && <span>{zoom.revista}</span>}
                            </div>
                            <button className="btn sm" onClick={() => setZoom(null)}>Fechar</button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

// Foto da peca: mesmo CDN da Frente de Loja usado pelo Express (<fornecedor><ref>.jpg).
// Nem toda peca tem foto — o 404 cai num painel com o wordmark, nunca em icone quebrado.
function FotoPeca({ src, alt, onZoom }) {
    const [falhou, setFalhou] = useState(false);
    const [pronta, setPronta] = useState(false);
    if (!src || falhou) {
        return (
            <div className="pp-prod-foto pp-prod-foto-vazia" aria-hidden="true">
                <BabitaLogo color="var(--pp-navy)" />
                <span>sem foto</span>
            </div>
        );
    }
    return (
        <button type="button" className={`pp-prod-foto ${pronta ? 'ok' : ''}`} onClick={onZoom} aria-label={'Ampliar ' + (alt || 'a peça')}>
            <img src={src} alt={alt || ''} width="300" height="400" loading="lazy"
                onLoad={() => setPronta(true)} onError={() => setFalhou(true)} />
            <span className="pp-prod-lupa" aria-hidden="true">＋</span>
        </button>
    );
}

function CardProduto({ p, i, onZoom }) {
    const tamanhos = Array.isArray(p.tamanhos) ? p.tamanhos.filter(Boolean) : [];
    const mostra = tamanhos.slice(0, 8);
    const resto = tamanhos.length - mostra.length;
    const cores = Array.isArray(p.cores) ? p.cores.filter(Boolean) : [];
    const ficha = [p.tecido, p.composicao, cores.length === 1 ? 'Cor da foto' : (cores.length > 1 ? cores.length + ' cores' : null)]
        .filter(Boolean).join(' · ');

    return (
        <article className="pp-prod-card pp-reveal" style={{ animationDelay: `${Math.min(i, 11) * 45}ms` }}>
            <FotoPeca src={p.foto} alt={p.descricao || 'Peça Babita'} onZoom={() => onZoom(p)} />
            <div className="pp-prod-corpo">
                {p.marca && <span className="pp-prod-marca">{p.marca}</span>}
                <h3 className="pp-prod-title">{p.descricao || 'Peça Babita'}</h3>
                <div className="pp-prod-ref">
                    {p.ref && <span className="mono">Ref. {p.ref}</span>}
                    {p.pagina && <span>Pág. {p.pagina}</span>}
                    {p.revista && <span className="pp-prod-rev">{p.revista}</span>}
                </div>
                {ficha && <div className="pp-prod-ficha">{ficha}</div>}
                {mostra.length > 0 && (
                    <div className="pp-chips">
                        {mostra.map((t, k) => <span key={k} className="chip">{String(t)}</span>)}
                        {resto > 0 && <span className="chip pp-chip-mais">+{resto}</span>}
                    </div>
                )}
            </div>
        </article>
    );
}

/* ------------------------------ Sobre a Babita ----------------------------- */

function SecaoHistoria() {
    const [itens, setItens] = useState(null);

    useEffect(() => {
        let alive = true;
        PublicoHistoria({}).then((r) => {
            if (!alive) return;
            setItens(r.Error ? [] : (Array.isArray(r.itens) ? r.itens : []));
        });
        return () => { alive = false; };
    }, []);

    if (itens && itens.length === 0) return null; // sem conteudo: nao mostra a secao

    return (
        <section className="pp-section">
            <div className="pp-section-head">
                <div className="eyebrow"><span className="num">04</span> Sobre a Babita</div>
                <h2 className="pp-section-title">Nossa história</h2>
            </div>

            {!itens && <div className="pp-note">Carregando…</div>}

            {itens && itens.length > 0 && (
                <div className="pp-hist-grid">
                    {itens.map((it, i) => (
                        <article
                            key={i}
                            className="pp-hist-card pp-reveal"
                            style={{ animationDelay: `${Math.min(i, 8) * 60}ms` }}
                        >
                            <h3 className="pp-hist-title">{it.titulo}</h3>
                            <p className="pp-hist-text">{it.texto}</p>
                            {it.fonte && <span className="pp-hist-fonte">{it.fonte}</span>}
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
}

/* =========================== MODO REVENDEDORA (CPF) =========================== */
// Mesma logica de Revendedora.jsx: normaliza digitos, valida via Contexto({solicitante,senha}),
// guarda a senha no modulo api.js (definirSenhaExterna) e faz login() com perfil Revendedora.
// Assim que login() roda, o ChatDireto troca para o chat (o motor le user.email = CPF).

function ModoRevendedora({ login, onVoltar }) {
    const [cpf, setCpf] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');

    async function entrar(e) {
        e.preventDefault();
        const cpfDigits = soDigitos(cpf);
        if (cpfDigits.length < 11 || cpfDigits.length > 14) {
            return setErro('Informe um CPF ou CNPJ válido.');
        }
        if (!senha) return setErro('Informe sua senha.');
        setErro('');
        setLoading(true);
        const r = await Contexto({ solicitante: cpfDigits, senha });
        setLoading(false);
        if (r.Error) return setErro(r.Error);
        if (!r.revendedora) return setErro('CPF/CNPJ ou senha inválidos.');
        definirSenhaExterna(senha);
        login({
            email: cpfDigits, senha, nome: r.nome || null,
            setor: 'Revendedora', cargo: 'Revendedora', ehRevendedora: true,
            deveTrocarSenha: !!r.deve_trocar_senha,
        });
    }

    return (
        <div className="pp-auth">
            <button className="pp-back" onClick={onVoltar} aria-label="Voltar">&larr; Explorar</button>
            <form className="login" onSubmit={entrar}>
                <div className="login-cover">
                    <div className="top">
                        <span>Babita · Portal da Revendedora</span>
                        <span className="right">Belo Horizonte · MG</span>
                    </div>
                    <div className="mid">
                        <div className="wordmark"><BabitaLogo color="var(--bg)" /></div>
                        <div className="tag">— Pergunte para o Babito sobre suas compras.</div>
                    </div>
                    <div className="bottom">
                        <span>Babita · v3.0</span>
                        <span className="legal">Acesso com CPF/CNPJ + senha</span>
                    </div>
                </div>

                <div className="login-form">
                    <div className="inner">
                        <div className="eyebrow" style={{ marginBottom: 20 }}>
                            <span className="num">01</span> Acesso da revendedora
                        </div>
                        <h2>Olá.</h2>
                        <p className="greet">Digite seu CPF ou CNPJ e a senha cadastrada para perguntar ao Babito sobre suas compras.</p>

                        <div className="field">
                            <label>CPF ou CNPJ</label>
                            <input
                                className="input"
                                type="text"
                                inputMode="numeric"
                                value={cpf}
                                onChange={(e) => setCpf(e.target.value)}
                                autoComplete="username"
                                placeholder="Só números"
                                autoFocus
                            />
                        </div>

                        <div className="field">
                            <label>Senha</label>
                            <input
                                className="input"
                                type="password"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                autoComplete="current-password"
                            />
                        </div>

                        {erro && <div className="erro" style={{ marginTop: 12, fontSize: 13, color: 'var(--danger, #a73838)' }}>{erro}</div>}

                        <button className="btn" type="submit" disabled={loading} style={{ marginTop: 14 }}>
                            {loading ? 'Entrando…' : 'Entrar'}
                        </button>

                        <div className="legal" style={{ marginTop: 22 }}>Babita · Portal da Revendedora</div>
                    </div>
                </div>
            </form>
        </div>
    );
}
